import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import SimpleReactValidator from "simple-react-validator";
import { Col, Row, Form, Spinner } from "react-bootstrap-v5";
import { DestinationCrossBorderService  } from "../../Services/DestinationCrossBorderService";
import { useHistory } from "react-router-dom";
import { locationServices } from "../../Services";

export const AddCrossBorder = () => {
  const [, setForceUpdate] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [state, setState] = useState({
    country_id: "",
    silla_border: "",
    batha_border: "",
    final_destination_charge: "",
    certificate_of_origin: "",
  });
  const history = useHistory();

  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSelectChange = (e) => {
    setState({ ...state, [e.name]: e.value });
  };

  const handleSubmit = () => {
    let validate = Validator.current.allValid();
    if (validate) {
      let params = { ...state };
      setLoader(true);
      DestinationCrossBorderService.addDestinationCrossBorder(params).then((res) => {
        if (res.status) {
          toast.success(res.msg);
          history.push("/cross-border-list");
          setLoader(false);
        } else {
          setLoader(false);
          toast.error(res.msg);
        }
      })
    } else {
      Validator.current.showMessages();
    }
  };

  const getCountryList = () => {
    setLoader(true);
    locationServices.getCountry().then((res) => {
      if (res.status) {
        let arry = [];
        res.data.forEach((list) => {
          arry.push({
            value: list._id,
            label: list.country_name,
          });
        });
        setLoader(false);
        setCountryList(arry);
      }
    });
  };
  useEffect(() => {
    getCountryList();
  }, []);

  return (
    <div style={{ height: "500px" }}>
      <div className="row" style={{ width: "50%" }}>
        <div className="card">
          <div className="card-body">
            <Form autoComplete="off">
              <Row className="p-3">
                {/* country  */}
                <Col md={12} className="mb-3">
                  <Form.Label>Country</Form.Label>
                  <Select
                    styles={{
                      valueContainer: (provided) => ({
                        ...provided,
                        overflowY: "visible",
                      }),
                    }}
                    placeHolder="Select Country"
                    onChange={(e) =>
                      handleSelectChange({ name: "country_id", value: e.value })
                    }
                    options={countryList}
                  />

                  {Validator.current.message(
                    "Country",
                    state.country_id,
                    "required",
                    { className: "text-danger" }
                  )}
                </Col>
                {/* silla_border  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Silla border</Form.Label>
                  <Form.Control
                    type="email"
                    name="silla_border"
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Charge"
                    value={state.silla_border}
                    autoComplete="new-password"
                  />
                  {Validator.current.message(
                    "silla border",
                    state.silla_border,
                    "required",
                    {
                      className: "text-danger",
                    }
                  )}
                </Col>
                {/* batha_border  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Batha border</Form.Label>
                  <Form.Control
                    type="text"
                    name="batha_border"
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Charge"
                    value={state.batha_border}
                  />
                  {Validator.current.message("batha border", state.batha_border, "required", {
                    className: "text-danger",
                  })}
                </Col>

                {/* final_destination_charge  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Final destination charge</Form.Label>
                  <Form.Control
                    type="email"
                    name="final_destination_charge"
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Charge"
                    value={state.final_destination_charge}
                    autoComplete="new-password"
                  />
                  {Validator.current.message("Final destination charge", state.final_destination_charge, "required", {
                    className: "text-danger",
                  })}
                </Col>

                {/* certificate_of_origin  */}
                <Col md={6} className="mb-3">
                  <Form.Label>Certificate of origins</Form.Label>
                  <Form.Control
                    type="email"
                    name="certificate_of_origin"
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Charge"
                    value={state.certificate_of_origin}
                    autoComplete="new-password"
                  />
                  {Validator.current.message("certificate of origin", state.certificate_of_origin, "required", {
                    className: "text-danger",
                  })}
                </Col>
              </Row>

              <Row className="mt-3">
                <Col md={12} className="d-flex justify-content-center">
                  <button
                    className="btn btn-danger w-sm waves-effect waves-light"
                    type="button"
                    onClick={() => history.goBack()}
                  >
                    Back
                  </button>
                  <button
                    className="btn btn-primary w-sm waves-effect waves-light ms-3"
                    type="button"
                    onClick={handleSubmit}
                  >
                    {(loader && <Spinner animation="grow" size="sm" />) ||
                      "Submit"}
                  </button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};
